import * as S from './DocumentTableSelector.styled';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

export enum TableSelection {
    GENERAL = 'GENERAL',
    POST_ITA = 'POST_ITA',
    POST_SUBMISSION = 'POST_SUBMISSION',
}

export type DocumentTableSelectorProps = {
    selection: TableSelection;
    handleSelection: (selection: TableSelection) => void;
    isPostItaDocs: boolean;
    isPostSubmissionDocs: boolean;
};

export default function DocumentTableSelector({
    selection,
    handleSelection,
    isPostItaDocs,
    isPostSubmissionDocs,
}: DocumentTableSelectorProps) {
    const { language_setting: language } = useSelector((state: RootState) => state.user.entity);
    const { t } = useTranslation();

    const LABELS: Record<TableSelection, string> = {
        [TableSelection.GENERAL]: t('general', { lng: language }),
        [TableSelection.POST_ITA]: isPostItaDocs ? t('postITA', { lng: language }) : '',
        [TableSelection.POST_SUBMISSION]: isPostSubmissionDocs
            ? t('postSubmission', { lng: language })
            : '',
    };

    const convertValue = (value: TableSelection) => t(LABELS[value], { lng: language });

    return (
        <S.SelectorParentDiv isHidden={!isPostItaDocs && !isPostSubmissionDocs}>
            <S.SelectionContainer>
                {Object.values(TableSelection)
                    .filter((value) => convertValue(value) !== '')
                    .map((value) => (
                        <S.SelectorItem
                            isActive={selection === value}
                            key={value}
                            onClick={() => handleSelection(value)}
                        >
                            {convertValue(value)}
                        </S.SelectorItem>
                    ))}
            </S.SelectionContainer>
        </S.SelectorParentDiv>
    );
}
